import { BreadcrumbsThemeType } from '@src/atoms/Breadcrumbs/models';
import { TColor } from '@src/models/common';

export const themeConfig: Record<
  BreadcrumbsThemeType,
  { mainLinkColor: TColor; lastLinkColor: TColor; iconView: TColor }
> = {
  dark: {
    mainLinkColor: 'basicWhite',
    lastLinkColor: 'basicGrey',
    iconView: 'basicGrey',
  },
  light: {
    mainLinkColor: 'basicBlack',
    lastLinkColor: 'basicGreySemiDark',
    iconView: 'basicGreySemiDark',
  },
};
